const action = {
    sign_in: 'เข้าสู่ระบบ',
    continue: 'ดำเนินการต่อ',
    continue_as: 'ดำเนินการต่อในชื่อ {{name}}',
    create_account: 'สร้างบัญชี',
    create_account_without_linking: 'สร้างบัญชีใหม่แทน',
    create: 'สร้าง',
    enter_passcode: 'กรอกรหัสยืนยัน',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    save_password: 'บันทึกรหัสผ่าน',
    bind: 'เชื่อมต่อกับ {{address}}',
    bind_and_continue: 'เชื่อมต่อและดำเนินการต่อ',
    back: 'กลับ',
    nav_back: 'ย้อนกลับ',
    nav_skip: 'ข้าม',
    agree: 'ยอมรับ',
    got_it: 'รับทราบ',
    sign_in_with: 'เข้าสู่ระบบด้วย {{name}}',
    forgot_password: 'ลืมรหัสผ่าน?',
    switch_to: 'เปลี่ยนเป็น {{method}}',
    sign_in_via_passcode: 'เข้าสู่ระบบด้วยรหัสยืนยัน',
    sign_in_via_password: 'เข้าสู่ระบบด้วยรหัสผ่าน',
    change: 'เปลี่ยน {{method}}',
    link_another_email: 'เชื่อมต่ออีเมลอื่น',
    link_another_phone: 'เชื่อมต่อเบอร์โทรศัพท์อื่น',
    link_another_email_or_phone: 'เชื่อมต่ออีเมลหรือเบอร์โทรศัพท์อื่น',
    show_password: 'แสดงรหัสผ่าน',
    copy: 'คัดลอก',
    verify_via_passkey: 'ยืนยันด้วยกุญแจรหัสผ่าน',
    download: 'ดาวน์โหลด',
    remove: 'ลบ',
    edit: 'แก้ไข',
    save: 'บันทึก',
    single_sign_on: 'เข้าสู่ระบบ SSO',
    authorize: 'อนุมัติ',
    use_another_account: 'ใช้บัญชีอื่น',
    back_to_current_account: 'กลับไปยังบัญชีปัจจุบัน',
    done: 'เสร็จสิ้น',
};
export default Object.freeze(action);
